import { IAppState } from '../../redux';
import { EMoneySource } from '../../redux/reducers';

// Счёт размещения для подачи объявления, может отличаться от счёта размещения в настройках пользователя
export function selectPlacingMoneySource(state: IAppState): EMoneySource | null {
  return state.publishTerms.moneySource || null;
}
